// src/app/interceptors/backend-network.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { BACKEND_URL_MAP } from '@/tokens/backend-url.token';

/**
 * Reescribe la URL de salida SOLO cuando la petición corre en SSR (Node),
 * cambiando el dominio público del backend por su equivalente en red
 * interna. En el navegador, BACKEND_URL_MAP llega vacío (ver app.config.ts)
 * y este interceptor es un no-op — la request sigue con su URL externa.
 */
export const backendNetworkInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isPlatformServer(inject(PLATFORM_ID))) {
    return next(req);
  }

  const urlMap = inject(BACKEND_URL_MAP);
  const mapping = urlMap.find(({ external }) => req.url.startsWith(external));

  console.log('BACKEND URL INTERCEPTORR ===============');
  console.log('BACKEND URL INTERCEPTORR - Mapping: ', mapping);
  console.log('BACKEND URL INTERCEPTORR - URL: ', req.url);

  if (!mapping || mapping.external === mapping.internal) {
    console.log('BACKEND URL INTERCEPTORR - USE EXTERNAL');
    return next(req);
  }
  console.log(
    'BACKEND URL INTERCEPTORR - CHANGE: ',
    mapping.internal + req.url.slice(mapping.external.length)
  );
  return next(
    req.clone({
      url: mapping.internal + req.url.slice(mapping.external.length),
    })
  );
};
